import React, { useContext, Fragment } from "react";

import AlertContext from "../../context/alert/alertContext";

import { Alert, Snackbar } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const Alerts = () => {
  const alertContext = useContext(AlertContext);
  const { alerts } = alertContext;

  const classes = useStyles();

  return (
    alerts.length > 0 && alerts.map((alert) => {
      return (
        <Fragment key={alert.id}>
          <div className={classes.root}>
            <Snackbar
              open={true}
              autoHideDuration={5000}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <Alert severity={alert.type}>{alert.msg}</Alert>
            </Snackbar>
          </div>
        </Fragment>
      );
    })
  );
};

export default Alerts;
